<template>
    <div class="form-pack">
        <h2 class="pack-pretitle">je €2 pakket</h2>

        <h3 class="pack-title">Je ontvangt</h3>
        <ul class="pack-list">
            <li>
                <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">
                <div>
                    <img class="pack-img" :src="form_side_image">
                    <strong>Je welkomstgeschenk uit tientallen merken</strong>
                </div>
            </li>
            <li>
                <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">Jouw magazines in zowel papieren als digitale versie
            </li>
            <li>
                <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">Onbeperkt juridisch, fiscaal en technisch advies
            </li>
            <li>
                <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">12 praktische gidsen naar keuze
            </li>
        </ul>

    </div>
</template>

<script>
import image_mixin from "./mixins/image_mixin";
export default {
    mixins:[
        image_mixin
    ]
}
</script>

<style lang="scss" scoped>

</style>
